module.exports = __webpack_public_path__ + "img/half_circle_shape.1e080b2a.svg";